import { IUser, IRepository, IOrganization, INamespace } from '@/types';
import { RepositoryAuthorization } from './repositoryAuthorization';
import { OrganizationAuthorization } from './organizationAuthorization';
import { NamespaceAuthorization } from './namespaceAuthorization';

export class Authorization {
  private user?: IUser;

  constructor(user?: IUser) {
    this.user = user;
  }

  /**
   * Check if user has a specific role
   */
  private hasRole(role: string): boolean {
    return this.user?.role === role;
  }

  isLoggedIn(): boolean {
    return !!this.user?.username;
  }

  isVerified(): boolean {
    return !!this.user?.username;
  }

  /**
   * Check if user is an admin
   */
  isAdmin(): boolean {
    const hasAccess = this.hasRole('admin');
    return hasAccess;
  }

  /**
   * Create a repository-specific authorization checker
   */
  forRepository(repository?: IRepository): RepositoryAuthorization {
    return new RepositoryAuthorization({ user: this.user, repository });
  }

  /**
   * Create an organization-specific authorization checker
   */
  forOrganization(organization?: IOrganization): OrganizationAuthorization {
    return new OrganizationAuthorization({ user: this.user, organization });
  }

  /**
   * Create a namespace-specific authorization checker
   */
  forNamespace(namespace?: INamespace): NamespaceAuthorization {
    return new NamespaceAuthorization({ user: this.user, namespace: namespace });
  }

  currentUser(): IUser | undefined {
    return this.user;
  }
}
